import { creditCardApply } from 'store/checkout/checkoutActions';
import { createCreditCardApplyEvent } from '../eventCreators';
import { createCreditCardApplyEventPayload } from '../dataHelpers/createCreditCardApplyEventPayload';

const emitCreditCardApplyEvent = ({ payload }) => {
  return createCreditCardApplyEvent(
    createCreditCardApplyEventPayload({
      itemName: payload.itemName,
      itemType: payload.itemType,
      provider: payload.provider,
      paymentType: payload.paymentType,
      url: payload.url,
      savedCard: payload.savedCard,
      index: payload.index,
      indexRange: payload.indexRange,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [creditCardApply]: emitCreditCardApplyEvent };
